import { IItemStats, ISKillsProgress, IUserInfoParams, IUserStatistics } from 'src/interfaces/user';
import { EAvatarType, ENetwork, ETree } from 'src/styles/theme/utils/enums';
import { IUser, IUserPersonalData, TUpdateUserMutation } from './userStore.type';

const defaultUserPersonalData: IUserPersonalData = {
	userId: 0,
	jwt: undefined,
	notificationJwt: undefined,
	username: '',
	hash: '',
	lastConnectionDate: undefined,
	avatarType: EAvatarType.unset,
	wallets: {
		[ENetwork.sepolia]: null,
		[ENetwork.starknetSepolia]: null
	},
	githubId: null,
	isSuperUser: false
};

// the key used to save the state in localStorage
const SAVED_USER_KEY = 'user';

// default value for the skills progress
const defaultSkillsProgress: ISKillsProgress = {
	level: 0,
	sumExpPoints: 0,
	[ETree.solidity]: {
		tools: 0,
		lowLevel: 0,
		dataStructure: 0,
		basicPattern: 0,
		advancedPattern: 0,
		basicSecurity: 0,
		advancedSecurity: 0,
		history: 0,
		protocols: 0,
		primitive: 0,
		ecosystem: 0,
		economy: 0
	},
	[ETree.noir]: {
		tools: 0,
		lowLevel: 0,
		dataStructure: 0,
		basicPattern: 0,
		advancedPattern: 0,
		basicSecurity: 0,
		advancedSecurity: 0,
		history: 0,
		protocols: 0,
		primitive: 0,
		ecosystem: 0,
		economy: 0
	},
	[ETree.general]: {
		tools: 0,
		lowLevel: 0,
		dataStructure: 0,
		basicPattern: 0,
		advancedPattern: 0,
		basicSecurity: 0,
		advancedSecurity: 0,
		history: 0,
		protocols: 0,
		primitive: 0,
		ecosystem: 0,
		economy: 0
	},
	[ETree.cairo]: {
		tools: 0,
		lowLevel: 0,
		dataStructure: 0,
		basicPattern: 0,
		advancedPattern: 0,
		basicSecurity: 0,
		advancedSecurity: 0,
		history: 0,
		protocols: 0,
		primitive: 0,
		ecosystem: 0,
		economy: 0
	}
};

const defaultItemStats: IItemStats = {
	common: 0,
	uncommon: 0,
	rare: 0,
	epic: 0,
	legendary: 0,
	unique: 0,
	total: 0,
	itemsCollected: 0,
	itemsReforged: 0,
	itemsSold: 0
};

const defaultUserStatistics: IUserStatistics = {
	// gold is the money of the user
	gold: 0,
	// the total gold collected by the user
	goldCollected: 0,
	// not used for the moment but will be used to generate stones
	dust: 0,
	// total campaign count
	campaignCount: 0,
	// all campaigns at least started by the user
	submitedCampaigns: [],
	// total quest count
	questCount: 0,
	// all quests at least started by the user
	submitedQuests: [],
	// user account creation date
	guardianSince: new Date(),
	// rank of the user
	rankNumber: 0,
	// count of started but not finished quests
	startedQuests: 0,
	// count of finished quests
	completedQuests: 0,
	// count of finished campaigns
	completedCampaigns: 0,
	// all items and chests of the user
	inventory: {
		chests: [],
		items: defaultItemStats
	},
	// skills progression of the user
	skillsProgress: defaultSkillsProgress
};

const defaultUserContext: IUser = {
	userPersonalData: defaultUserPersonalData,
	userStatistics: defaultUserStatistics,
	setUserPersonalData: () => {},
	login: () => Promise.resolve(),
	logout: () => Promise.resolve(),
	updateUserStatistics: () => {},
	fetchUserStatistics: () => {},
	//updateUserInfo: (() => {}) as unknown as TUpdateUserMutation,
	updateUserInfo: {
		mutate: (user: IUserInfoParams) => {},
		isLoading: true,
		isError: true
	} as unknown as TUpdateUserMutation,
	//updateUserInfo: (user: IUserInfoParams) => Promise.resolve({}),
	isSuperUser: false
};

export {
	SAVED_USER_KEY,
	defaultItemStats,
	defaultSkillsProgress,
	defaultUserContext,
	defaultUserPersonalData,
	defaultUserStatistics
};
